/* eslint-disable require-jsdoc */
export default function announceForAccessibility(message, callBack) {
  if (typeof document === "undefined") return
  const el = document.getElementById("site-announcer")
  if (el) {
    el.textContent = message
    // Clear it after a short time so same message can be re-announced later
    setTimeout(() => {
      callBack && callBack()
    }, 4000)
  }
}
